import { render, staticRenderFns } from "./scholar-ships-by-code.vue?vue&type=template&id=01cdfcdd&"
import script from "./scholar-ships-by-code.vue?vue&type=script&lang=js&"
export * from "./scholar-ships-by-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports